import { clsx } from "clsx";

interface TagBadgeProps {
  label: string;
  variant?: "category" | "keyword" | "policy" | "risk" | "default";
  onClick?: () => void;
}

const VARIANT_STYLES: Record<string, string> = {
  category: "text-ink-tertiary bg-surface-sunken border-border",
  keyword:  "text-ink-tertiary bg-surface-sunken border-border",
  policy:   "text-ink-secondary bg-surface-sunken border-border font-semibold",
  risk:     "text-ink-secondary bg-surface-sunken border-border-strong font-semibold",
  default:  "text-ink-tertiary bg-surface-sunken border-border",
};

export function TagBadge({ label, variant = "default", onClick }: TagBadgeProps) {
  return (
    <span
      className={clsx(
        "inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium border leading-none tracking-wide select-none",
        VARIANT_STYLES[variant] ?? VARIANT_STYLES.default,
        onClick && "cursor-pointer hover:opacity-80 active:scale-[0.97] transition-all duration-100"
      )}
      onClick={onClick}
    >
      {label}
    </span>
  );
}
